// import React from 'react';
// import Hero from '../../common/Hero';

// const heroData = {
//   title: [
//     '[',
//     { text: 'Partner', color: 'orange' },
//     { text: 'Name', color: 'purple' },
//     ']'
//   ],
//   description: "At [Bank Name], we believe financial freedom starts with the right tools. That's why we've designed a range of products tailored to meet your needs—whether you're saving for the",
//   backgroundImage: ladyOnPhone
// };

// const HeroSection = () => {
//   return <Hero {...heroData} />;
// };

// export default HeroSection;

import ladyOnPhone from "../../../assets/images/home/lady-on-phone.webp";
import Hero from "../../common/Hero";

const heroTitle = [
  'Welcome to <span class="font-bold text-purple-300">Sim</span><span class="font-bold text-orange-400">Finance</span><span class="text-white"> -</span>',
  "Ghana's Premier Financial",
  "Marketplace",
];

const heroDescription = [
  "Our secure and user-friendly platform serves as a one-stop",
  "destination that connects you with a wide range of trusted financial institutions.",
];

export const HeroPage = () => {
  return (
    <Hero
      titleLines={heroTitle}
      description={heroDescription}
      backgroundImage={ladyOnPhone}
    />
  );
};
